export default "__VITE_ASSET__da4381e1__"